import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { ActionIcon } from '@mummssoftware/common-ui';
import { SingleTaskPlanner } from './SingleTaskPlanner';
import { useStyles } from './style';
import {
  OtherTaskPlannerDiv,
  TasksDiv,
  TaskDiv,
} from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

type TaskPlannerProps = {
  otherTask?: mumms.PatientCppTask[] | null;
  readOnly?: boolean;
};

type TaskOther = mumms.PatientCppTask & { taskid: number };

export const OtherTaskPlanner = ({ otherTask, readOnly }: TaskPlannerProps) => {
  const classes = useStyles();

  const [isCollapsed, setCollapsed] = useState<boolean>(false);

  const [otherTasks, setOtherTasks] = useState<TaskOther[]>([]);
  const [count, setCount] = useState<number>(0);
  const showOtherTask = !!(otherTasks && otherTasks.length);

  const collpaseTasks = () => {
    setCollapsed(!isCollapsed);
  };

  const addTask = () => {
    if (otherTask) {
      // for the key of OtherTask to be registered
      setCount(count + 1);
      const addtTask = { ...otherTask[0], taskid: count };
      const addtTasks = [...[addtTask], ...otherTasks];
      setOtherTasks(addtTasks);
    }
  };

  const getTitle = () => (
    <TaskDiv>
      <Typography
        variant="body1"
        className={classes.boldTitle}
        onClick={collpaseTasks}
      >
        {defaults.patientTasks}
      </Typography>
      {otherTask && (
        <ActionIcon
          style={{
            margin: 0,
          }}
          Icon={AddIcon}
          onClick={addTask}
        />
      )}
    </TaskDiv>
  );

  const getOtherTasks = () =>
    otherTasks && otherTasks.length ? (
      <>
        {otherTasks.map((task: TaskOther) => (
          <SingleTaskPlanner editTaskMode task={task} key={task.taskid} />
        ))}
      </>
    ) : (
      <></>
    );

  const getUI = () => (
    <OtherTaskPlannerDiv id="other-task-planner">
      {getTitle()}
      <TasksDiv>{showOtherTask && getOtherTasks()}</TasksDiv>
    </OtherTaskPlannerDiv>
  );

  return <>{readOnly ? <></> : getUI()}</>;
};
